import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { DESK_COMMUNICATION_EVENTS } from "models";

import type { DeskCommunicationEvent } from "models";

type SignatureProps = {
  events?: DeskCommunicationEvent[];
};

export const Signature = ({ events }: SignatureProps) => {
  const { t } = useTranslation();
  if (!events) return null;

  const event = events.find(e => e.type === DESK_COMMUNICATION_EVENTS.DeskCheckInAnswered);
  if (!event?.customer_signature) return null;

  return (
    <div className="desk-comm-section-container">
      <div className="desk-comm-section-header">{t("v8_signature", "Signature")}</div>

      <Grid>
        {event.customer_name && (
          <Grid.Row>
            <Grid.Column width={16}>
              <span>
                <FontAwesomeIcon icon={faUser} className="i-green mr-5" />
                {event.customer_name}
              </span>
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Column width={4} className="signature-img-container">
            <img src={event.customer_signature} className="signature-img" alt="signature" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};
